export default {
    cz: {
        pricePerUnit: (unit: string) => `za ${unit} s DPH`,
    },
    sk: {
        pricePerUnit: (unit: string) => `za ${unit} s DPH`,
    },
}
